//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "swiper/dist/css/swiper.css";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {
  postureHome,
} from "../assets/lang.conf/root";
var langs = {
  en: "中文",
  cn: "English"
};
export default {
  name: "Posture_home",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      ...postureHome
    }
  },
  directive: {
    bModalDirective
  },
  components: {},
  props: ["coverInfo"],
  data() {
    return {
      oldUrl: "",
      locale: "",
      langTag: this.$i18n.locale,
      localUrl: "",
      localeText: langs[this.$i18n.locale]

      // localeText:this.langs[this.$i18n.locale],
    };
  },
  methods: {
    slideIn: function() {
      this.$emit("slideIn");
    },
    changeLang: function(lang) {
      this.locale = lang;
      var changeUrl =
        location.href.substring(0, location.href.lastIndexOf("language")) +
        "language=" +
        lang;
      console.log("changeUrl" + changeUrl);
      console.log({
        locale: this.locale,
        text: this.$i18n.locale
      });
      location.href = changeUrl;
      this.$i18n.locale = lang;
      this.localeText = this.langs[lang] || "English";
      setTimeout(function() {
        this.localUrl = changeUrl;
      }, 200);
      // location.reload()
      // this.$emit('changeLang',this.locale)
    }
  },

  computed: {
    show: function() {
      //console.log('indexPage:', this.$t('indexPage.show'))
      return this.$t("indexPage.show");
    }
  },
  created() {
    // var pathUrl = location.href.match(/(\w+)=(\w+)/g)
    // var pathObj = {};
    // for (var i = 0; i < pathUrl.length; i++) {
    //   var pathItem = pathUrl[i].split('=')
    //   pathObj[pathItem[0]] = pathItem[1] || ''
    // }
    // this.$i18n.locale = pathObj.language || 'cn'
    console.log({
      index: this.$i18n.locale
    });
    var changeLangTag = this.$i18n.locale;

    // console.log((document.title = "Posture Report"));
    var pos = location.href.lastIndexOf("language");
    if (pos > 0) {
      this.localUrl =
        location.href.substring(0, pos) + "language=" + changeLangTag;
    } else {
      console.log({
        url: location.href
      });
      var spLength = location.href.length - 2;
      this.localUrl =
        location.href.substring(0, spLength) + "&language=" + changeLangTag;
    }
  }
  // watch: {
  //   locale (val) {
  //     this.$i18n.locale = val
  //   }
  // }
};



// WEBPACK FOOTER //
// ./src/components/Posture_home.vue